import { render, staticRenderFns } from "./TabelaDeItens.vue?vue&type=template&id=df9aab42&scoped=true"
import script from "./TabelaDeItens.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeItens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeItens.vue?vue&type=style&index=0&id=df9aab42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9aab42",
  null
  
)

export default component.exports